import { AnimationFrame } from './AnimationFrame';
import { mat4 } from 'gl-matrix';

export type JointType = {
  name: string;
  frames: { [key: string]: AnimationFrame[] };
};

export abstract class Animation {
  public abstract reference: string;
  public abstract bindShapeMatrix: mat4;
  public abstract validAnimation: boolean;
  public abstract joints: JointType[];
  public abstract getJointIndex(name: string): number | undefined;
}
